var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.9369 8.90013-5.6553-.49075-2.2083-5.19955c-.3973-.94644-1.7527-.94644-2.15 0l-2.20833 5.21124-5.64356.47906c-1.02823.08179-1.44887 1.36707-.66601 2.04477l4.28817 3.7156-1.28528 5.5151c-.23369 1.0048.85296 1.7994 1.74097 1.2619l4.84904-2.9211 4.849 2.9328c.888.5375 1.9747-.2571 1.741-1.2619l-1.2853-5.5268 4.2882-3.7156c.7828-.6777.3739-1.96298-.6543-2.04477zm-8.9386 7.43127-4.39334 2.6524 1.16844-5.001-3.87922-3.3651 5.11772-.444 1.9864-4.70878 1.998 4.72048 5.1178.444-3.8792 3.3651 1.1684 5.001z",
    fill: "#000"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.0e447628.svg";
export { ForwardRef as ReactComponent };